var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"helper",staticClass:"need-help",attrs:{"id":"helper"},on:{"click":_vm.push2QA}},[_c('img',{ref:"buttonImg",attrs:{"src":require('@/assets/image/qaq.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }